import React, {useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './ChoixSiegePage.scss'
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const ChoixSiegePage: React.FC = ({}) => {
    const {t} = useTranslation(['choixSiege', 'common'])
    const navigate = useNavigate()

    const [choice, setChoice] = useState<string | null>(null)

    return (
        <BasePage showLogo showHistorique showPanier>
            <p className="choixSiegePageText">{t('instructions')}</p>
            <p className="choixSiegePageSubText">{t('help')}</p>
            <input className="choixSiegePageInput" placeholder={t('placeholder')} onKeyUp={(e: any) => setChoice(e.target.value)}/>
            <BaseButton onClick={() => navigate('/menu')} text={t('common:actions.validate')} className="choixSiegePageBtn" disabled={!choice}/>
        </BasePage>
    )
}

export default ChoixSiegePage;
